import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid } from '../../common';
import { APIEndpoint } from '../../utils/axios';

const ERROR_TYPES = [
  { label: 'All Types', value: '' },
  { label: 'IROP', value: 'IROP' },
  { label: 'API ERROR', value: 'API_ERROR' },
  { label: 'SSR', value: 'SSR' },
];

export const AlertswaringsPage = () => {
  const { t, ready } = useTranslation();

  const [errorType, setErrorType] = useState('');

  const columns = useMemo(
    () => [
      {
        field: 'title',
        headerName: 'Title',
        flex: 1,
        suppressSizeToFit: true,
        cellRenderer: params => {
          return <span>{t(params.value)}</span>;
        },
      },
      {
        field: 'message',
        headerName: 'Error Message',
        flex: 2,
        suppressSizeToFit: true,
        cellRenderer: params => {
          return <span>{t(params.value)}</span>;
        },
      },
      {
        field: 'type',
        headerName: 'Error Type',
        width: 180,
        cellRenderer: params => {
          return <span>{t(params.value)}</span>;
        },
      },
    ],
    [t],
  );

  const fetchNotifications = useCallback(
    async (page = 1, perPage = 50) => {
      try {
        const queryParams = new URLSearchParams({
          page: page.toString(),
          limit: perPage.toString(),
        });

        if (errorType) {
          queryParams.append('type', errorType);
        }

        const { data } = await APIEndpoint.get(
          `event-notifications?${queryParams.toString()}`,
        );
        return {
          items: data?.notifications ?? [],
          count: data?.totalCount ?? 0,
        };
      } catch (error) {
        return {
          items: [],
          count: 0,
        };
      }
    },
    [errorType],
  );

  return (
    <div className="flexCol full-flex ag-theme-alpine-dark">
      <div className="flexRow margTop8 margBot10">
        <select
          className="select-item"
          value={errorType}
          onChange={e => setErrorType(e.target.value)}
        >
          {ERROR_TYPES.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flexCol full-flex">
        <DataGrid
          key={errorType} // Forces reload when filter changes
          className="full-flex"
          columns={columns}
          getRows={fetchNotifications}
          showDefaultFilters={false}
          rowModelType="infinite"
          rowSelection="multiple"
          pagination
          paginationPageSize={20}
          paginationAutoPageSize={false}
          columnResize
        />
      </div>

      {!ready && <div className="overlay_hide sub" />}
    </div>
  );
};
